import { IComponentOptions, IController, IPromise } from "angular";
import { BadgeService, IExtendedBadgeAssignment } from "@gtmhub/badges";
import { GtmhubController } from "@gtmhub/core";
import { ApmSpanService } from "@gtmhub/core/tracing/apm-span.service";
import { CurrentEmployeeActions, ICurrentEmployeeStoreState, IEmployee } from "@gtmhub/employees";
import { IUIError, UIErrorHandlingService } from "@gtmhub/error-handling";
import { IGtmhubRootScopeService } from "@gtmhub/models";
import { IExtendedRootScopeService } from "@gtmhub/shared/ng-extensions";
import { INgRedux } from "@gtmhub/state-management";

const bindStateToCtrl = (state: ICurrentEmployeeStoreState): IHomeFeedNavBarCtrlRedux => {
  const { info: currentEmployee, isFetched: currentEmployeeFetched, error: currentEmployeeError } = state.currentEmployee;

  return {
    reduxStatesInitialized: currentEmployeeFetched,
    reduxStateError: currentEmployeeError,
    employee: currentEmployee,
  };
};

interface IHomeFeedNavBarCtrlRedux {
  employee: IEmployee;
  reduxStatesInitialized: boolean;
  reduxStateError: IUIError;
}

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface HomeFeedNavBarCtrl extends IHomeFeedNavBarCtrlRedux {}
export class HomeFeedNavBarCtrl extends GtmhubController implements IController {
  public loading: boolean;
  public badgeAssignments: IExtendedBadgeAssignment[];
  public isMsTeamsState: boolean;
  public hasPermission: (action: string) => boolean;
  public featureAvailable: (name: string) => boolean;

  public static $inject = ["$rootScope", "$scope", "$ngRedux", "UIErrorHandlingService", "CurrentEmployeeActions", "BadgeService", "ApmSpanService"];

  constructor(
    $rootScope: IGtmhubRootScopeService,
    private $scope: IExtendedRootScopeService,
    private $ngRedux: INgRedux,
    private uiErrorHandlingService: UIErrorHandlingService,
    private currentEmployeeActions: CurrentEmployeeActions,
    private badgeService: BadgeService,
    private apmSpanService: ApmSpanService
  ) {
    super();

    this.isMsTeamsState = $rootScope.isMsTeamsState;
    this.hasPermission = $rootScope.hasPermission.bind($rootScope);
    this.featureAvailable = $rootScope.featureAvailable.bind($rootScope);
    this.loading = true;
    this.onDestroy(this.$ngRedux.connect(bindStateToCtrl)(this));
  }

  $onInit(): void {
    this.$ngRedux.dispatch(this.currentEmployeeActions.fetchCurrentEmployeeIfMissing());

    this.$scope
      .watchUntilAndRejectOnError(
        () => this.reduxStatesInitialized,
        () => this.reduxStateError
      )
      .then(
        () => this.getCurrentUserBadgeAssignments(),
        () => this.handleError(this.reduxStateError)
      )
      .then(() => {
        this.loading = false;
      })
      .catch((error) => {
        this.handleError(error);
      });
  }

  private getCurrentUserBadgeAssignments = (): IPromise<unknown> => {
    return this.apmSpanService.dataLoadSpan("badges-load", () => {
      return this.badgeService.getCurrentUserBadgeAssignments().then((badgeAssignments) => {
        this.badgeAssignments = badgeAssignments;
      });
    });
  };

  private handleError = <E>(error: E): void => {
    this.uiErrorHandlingService.handleModal(error);
  };
}

export const HomeFeedNavBarComponent: IComponentOptions = {
  bindings: {
    hideActionButtons: "<?",
    title: "<?",
  },
  controller: HomeFeedNavBarCtrl,
  template: require("./home-feed-nav-bar.component.html"),
};
